import $ from 'jquery';
import eventBus from 'EventBus';
import util from 'util/Util';
import themeService from 'ThemeService';
import undoService from 'UndoService'
import pageSyncService from 'PageSyncService'
import focusController from 'FocusController';
import {pickerCfg} from 'pickerCfg';
import BasePropertyView from 'BasePropertyView';
import formatTemplate from 'properties/theme/checkboxes.ejs';
import Immutable        from 'immutable';
import constants from 'Constants';
import fontService from 'FontService';

const SILENT = constants.MODEL_SILENT;

class CheckboxesView extends BasePropertyView {

  initialize(opts) {
    super.initialize(opts);

    this.options = opts || {};
    this.template = formatTemplate;
    this.tagName = 'div';
    this.id = opts.el;

    this.selectedColor = 'lightgrey';
    this.unselectedColor = 'transparent';

    this.initializeTextAttributes();
    this.model.set('selectionBorderColor', themeService.resolve('~selectionBorderColor'), SILENT);
    this.model.set('selectionBgColor', themeService.resolve('~selectionBgColor'), SILENT);
    this.model.set('selectionBgGradientColor', themeService.resolve('~selectionBgGradientColor'), SILENT);
    this.model.set('checkBgTransparent', util.isTrue(themeService.resolve('~checkBgTransparent')), SILENT);

    this.events = {
      'change input[type=text]': 'updateAttributes',
      'change input[type=color]': 'updateColorAttributes',
      'change input[type=checkbox]': 'updateTransparentBackground',
      'blur input[type=text]': 'lostFocus',
      'focus input[type=text]': 'getFocus',
      'change select': 'updateSelectAttributes',
      'click .styleSelectorCheckbox': 'updateTextStyleAttributes',
      'click .weightSelectorCheckbox': 'updateTextWeightAttributes'
    };

    this.listenTo(this.model, 'change', this.render);

    // Child class would override, supplying a list of model properties that need a sticky dropdown selection.
    this.dropdownPropNames = Immutable.List(['checkboxFont', 'checkboxFontSize']);

    return this;
  }

  initializeTextAttributes() {
    this.model.set('selectionTextColor', themeService.resolve('~selectionTextColor'), SILENT);
    this.model.set('selectionTextOverColor', themeService.resolve('~selectionTextOverColor'), SILENT);

    var fontProp = themeService.resolve('~selectionFont').split(',');

    this.model.set('checkboxFont', fontProp[0].trim(), SILENT);
    this.model.set('checkboxFontSize', fontProp[1].trim(), SILENT);

    if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('bold') > -1) ||
        (fontProp[3] && fontProp[3].toLowerCase().indexOf('bold') > -1)) {
      this.model.set('checkboxTextWeight', 'bold !important', SILENT);
    } else {
      this.model.set('checkboxTextWeight', 'normal !important', SILENT);
    }
    if (this.model.get('checkboxTextWeight') === 'normal !important') {
      this.model.set('checkboxTextWeightSelection', this.unselectedColor, SILENT);
    } else {
      this.model.set('checkboxTextWeightSelection', this.selectedColor, SILENT);
    }

    if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('italic') > -1) ||
        (fontProp[3] && fontProp[3].toLowerCase().indexOf('italic') > -1)) {
      this.model.set('checkboxTextStyle', 'italic !important', SILENT);
    } else {
      this.model.set('checkboxTextStyle', 'normal !important', SILENT);
    }
    if (this.model.get('checkboxTextStyle') === 'normal !important') {
      this.model.set('checkboxTextStyleSelection', this.unselectedColor, SILENT);
    } else {
      this.model.set('checkboxTextStyleSelection', this.selectedColor, SILENT);
    }

  }

  updateThemeFontAttributes() {
    const themePropArray = [this.model.get('checkboxFont'), this.model.get('checkboxFontSize'), this.model.get('checkboxTextWeight'), this.model.get('checkboxTextStyle')];
    themeService._theme['~selectionFont'] = themePropArray.join(',');
  }

  updateTextStyleAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;

    let style = this.model.get(propName);
    let oldValue = this.model.get(propName);

    if (this.model.get(propName).indexOf('italic') > -1) {
      this.model.set(propName + 'Selection', this.unselectedColor, SILENT);
      style = 'normal !important';
    } else {
      this.model.set(propName + 'Selection', this.selectedColor, SILENT);
      style = 'italic !important';
    }

    this.model.set(propName, style, SILENT);
    this.updateThemeFontAttributes();
    this.render();
    eventBus.trigger('CheckboxThemeChange');

    undoService.add({
      undo: () => {
        if (oldValue.indexOf('italic') > -1) {
          this.model.set(propName + 'Selection', this.selectedColor, SILENT);
        } else {
          this.model.set(propName + 'Selection', this.unselectedColor, SILENT);
        }
        this.model.set(propName, oldValue, SILENT);
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        //this.model.trigger('change', this.model);
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      },
      redo: () => {
        if (style.indexOf('italic') > -1) {
          this.model.set(propName + 'Selection', this.selectedColor, SILENT);
        } else {
          this.model.set(propName + 'Selection', this.unselectedColor, SILENT);
        }
        this.model.set(propName, style, SILENT);
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        //this.model.trigger('change', this.model);
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      }
    })
  }

  updateTextWeightAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;

    let weight = this.model.get(propName);
    let oldValue = this.model.get(propName);

    if (this.model.get(propName).indexOf('bold') > -1) {
      this.model.set(propName + 'Selection', this.unselectedColor, SILENT);
      weight = 'normal !important';
    } else {
      this.model.set(propName + 'Selection', this.selectedColor, SILENT);
      weight = 'bold !important';
    }

    this.model.set(propName, weight, SILENT);
    this.updateThemeFontAttributes();
    this.render();
    eventBus.trigger('CheckboxThemeChange');

    undoService.add({
      undo: () => {
        if (oldValue.indexOf('bold') > -1) {
          this.model.set(propName + 'Selection', this.selectedColor, SILENT);
        } else {
          this.model.set(propName + 'Selection', this.unselectedColor, SILENT);
        }
        this.model.set(propName, oldValue, { silent: true });
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        //this.model.trigger('change', this.model);
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      },
      redo: () => {
        if (weight.indexOf('italic') > -1) {
          this.model.set(propName + 'Selection', this.selectedColor, SILENT);
        } else {
          this.model.set(propName + 'Selection', this.unselectedColor, SILENT);
        }
        this.model.set(propName, weight, SILENT);
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        //this.model.trigger('change', this.model);
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      }
    })
  }

  updateAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;
    const propVal = ev.currentTarget.value;
    const propColorName = propName.replace('Color', '');
    const oldPropVal = this.model.get(propName);
    const oldThemeValue=themeService._theme['~' + propName];

    if (util.isValidColorcode(propVal)) {
      let color = this.resolveColor(propVal);

      this.model.set(propName, color,SILENT);
      themeService._theme['~' + propName] = color;
      this.render();
      $('#' + propName).val(color);
      this.addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,color);
      eventBus.trigger('CheckboxThemeChange');
    }
    else {
      this.model.set(propName, $('#' + propColorName).val());
    }
  }

  updateColorAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;
    const propVal = ev.currentTarget.value;
    const oldPropVal = this.model.get(propName);
    const oldThemeValue=themeService._theme['~' + propName];

    let color = this.resolveColor(propVal);
    this.model.set(propName, color,SILENT);
    this.render();
    $('#' + propName).val(color);
    themeService._theme['~' + propName] = color;
    this.addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,color);
    eventBus.trigger('CheckboxThemeChange');
  }

  updateTransparentBackground(ev){
    ev.preventDefault();
    const propName = ev.currentTarget.name;
    const propVal = ev.currentTarget.checked;
    const oldPropVal = this.model.get(propName);

    this.model.set(propName, propVal, SILENT);
    themeService._theme['~' + propName] = propVal;
    this.render();
    eventBus.trigger('CheckboxThemeChange');
   
    undoService.add({
      undo: () => {
        themeService._theme['~' + propName] = oldPropVal;
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      },
      redo: () => {
        themeService._theme['~' + propName] = propVal;
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      }
    });
    
  }

  addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,currentColor){
    undoService.add({
      undo:() => {
        this.model.set(propName, oldPropVal,SILENT);
        themeService._theme['~' + propName] = oldThemeValue;
        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
        $('#' + propName).val(oldPropVal);
      },
      redo: () => {
        this.model.set(propName, currentColor,SILENT);
        themeService._theme['~' + propName] = currentColor;
        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
        $('#' + propName).val(currentColor);
      }
    })
  }

  updateSelectAttributes(ev, name, val) {
    ev.preventDefault();
    const propName = name || ev.currentTarget.name;
    const propVal = val || ev.currentTarget.value;
    const oldPropVal = this.model.get(propName);

    this.model.set(propName, propVal,SILENT);
    this.updateThemeFontAttributes();
    this.render();
    eventBus.trigger('CheckboxThemeChange');

    undoService.add({
      undo:() => {
        this.model.set(propName, oldPropVal,SILENT);
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      },
      redo: () => {
        this.model.set(propName, propVal,SILENT);
        this.updateThemeFontAttributes();
        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      }
    })
  }


  render() {
    super.render();

    if (this.template) {
      this.$el.html(this.template(this.model.toJSON()));
    }

    util.prepareComboWidget(this.$el, this);

    this.createEditableDropDown('checkboxFontSize');

    const fonts = fontService.loadFontsDropDown(false);
    $("#checkboxFont").append(fonts);


    //.$('input[type=color]', this.$el).spectrum(pickerCfg);

    this.updateForm();
    this.delegateEvents();

    return this;
  }

}

export default CheckboxesView;
